import { useSidebar } from '../contexts/SidebarContext';

export default function MainLayout({ children }) {
  const { isCollapsed } = useSidebar();
  
  return (
    <div className={`min-h-screen transition-all duration-300 pt-16 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
      <div className="w-full h-full flex flex-col">
        {children}
      </div>
    </div>
  );
}
